import type { ComponentLoaderType } from '@grafikr/components';
import { getCountryIntent, getRegionIntent, getCurrentRegion } from 'utils/geo';
import isbot from 'isbot';

const Loader: ComponentLoaderType = (_, load) => {
  (async () => {
    // Return early if user agent is a bot
    if (isbot(navigator.userAgent)) {
      return;
    }

    const currentCountry = await getCountryIntent();
    const currentRegion = getCurrentRegion();
    const regionMatch = getRegionIntent(currentCountry);

    if (currentRegion.domain !== regionMatch.domain) {
      load();
    }
  })();

  return () => {};
};

export default Loader;
